import React, { useState, useEffect } from "react";
import Pie from "@amzn/meridian/pie";
import Legend, { LegendProvider } from "@amzn/meridian/legend";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Heading from "@amzn/meridian/heading";
import { useAppSelector } from "src/store/store";
import "./auditReview/auditReviewView.scss";
import Loader from "@amzn/meridian/loader";
import { getRatio } from "src/components/pages/audit/helpers";
import { AuditStatus } from "src/store/auditSlice";

export interface DonutChartProps {
  key: string;
  value: number;
  color: string;
  label: string;
}

const DonutChart = () => {
  const widthRatio = 0.07;
  const [pieWidth, setPieWidth] = useState(window.innerWidth * widthRatio);

  useEffect(() => {
    const handleResize = () => {
      setPieWidth(window.innerWidth * widthRatio);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { auditDataListView, getListViewLoading } = useAppSelector((state) => state.auditSlice);

  const auditTotalCount = auditDataListView.length;

  const reviewedCount = auditDataListView.filter(
    (item) => item.status === AuditStatus.REVIEWED,
  ).length;

  const unReviewedCount = auditTotalCount - reviewedCount;

  const data: DonutChartProps[] = [
    {
      value: unReviewedCount,
      key: "unreviewed",
      color: "#D9D9D9",
      label: "Unreviewed",
    },
    {
      value: reviewedCount,
      key: "reviewed",
      color: "#36c2b4",
      label: "Reviewed",
    },
  ];

  if (getListViewLoading === "pending") return <Loader></Loader>;

  return auditTotalCount === 0 ? (
    <Text>Fail to extract incident</Text>
  ) : (
    <Row spacingInset={"400"} className="donut-chart">
      <LegendProvider data={data}>
        <Row spacing="400" alignmentHorizontal="center" alignmentVertical="top">
          <Pie width={pieWidth} data={data} donutRatio={0.7}>
            <Text type="h100" tag="div">
              {getRatio(data)}
            </Text>
            <Text type="b100" tag="div">
              unreviewed
            </Text>
          </Pie>
          <Column>
            <Heading id="animals-one" level={6}>
              Cases yet to be reviewed
            </Heading>
            <Legend direction="vertical" values={(item) => item.value.toLocaleString()} />
          </Column>
        </Row>
      </LegendProvider>
    </Row>
  );
};

export default DonutChart;
